import styled from 'styled-components'

export default styled.div`
  .spinner-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: ${document.body.clientHeight}px;
    background: rgba(1, 1, 1, 0.5);
    z-index: 1000;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: 50px;
    padding-bottom: 100px;
  }
  .middle-spinner {
    margin: 0;
    position: absolute;
    width: auto;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`



// WEBPACK FOOTER //
// ./src/styles/SpinnerWithOverlay.js